function initializeSizeRedirectButton() {
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize magnifying glass tooltips
    initializeMagnifyingGlassTooltips();
    
    const shippingInfoBar = document.getElementById('shipping-info-bar');
    const shippingInfoText = document.getElementById('shipping-info-text');
    
    if (shippingInfoBar && shippingInfoText) {
      function updateShippingBar() {
        const currentVendor = productData.vendor;
        const selectedSize = getSelectedSize();
        const selectedInput = document.querySelector('input[name*="Size"]:checked, input[name*="Maat"]:checked, input[data-size]:checked');
        const isUnavailable = selectedInput?.hasAttribute('data-unavailable');

        if (isUnavailable) {
          // Change to redirect state
          shippingInfoBar.classList.add('redirect-state');
          
          let buttonText;
          // Check if size is a letter (clothing size)
          const isClothingSize = selectedSize && /^(XS|S|M|L|XL|XXL|XXXL|[A-Z])$/i.test(selectedSize.trim());
          
          if (isClothingSize) {
            // Text for clothing items
            buttonText = `Bekijk <b>${currentVendor}</b> kleding in maat <b>${selectedSize}</b> →`;
          } else {
            // Convert size to number for shoe sizes
            const sizeNumber = parseInt(selectedSize);
            const isChildrensSize = !isNaN(sizeNumber) && sizeNumber <= 35;
            
            if (isChildrensSize && selectedSize) {
              buttonText = `Bekijk sneakers in kindermaat <b>${selectedSize}</b> →`;
            } else if (currentVendor && selectedSize) {
              buttonText = `Bekijk <b>${currentVendor}</b> sneakers in maat <b>${selectedSize}</b> →`;
            } else {
              buttonText = currentVendor
              ? `Bekijk andere <b>${currentVendor}</b> accessoires →`
              : 'Bekijk andere accessoires →';
            }
          }
          
          shippingInfoText.innerHTML = buttonText;
          
          // Add click handler for redirect
          shippingInfoBar.onclick = handleSizeRedirect;
        } else {
          // Reset to original shipping state
          shippingInfoBar.classList.remove('redirect-state');
          shippingInfoText.innerHTML = 'Wordt binnen <strong>24 uur</strong> verzonden';
          shippingInfoBar.onclick = null;
        }
      }

      // Add event listeners for size changes
      document.querySelectorAll('input[name*="Size"], input[name*="Maat"], input[data-size]').forEach(input => {
        input.addEventListener('change', updateShippingBar);
      });
    }
  });
}

function getCollectionConfig(selectedSize) {
  const cleanSize = (selectedSize || '').trim();
  if (/^(XS|S|M|L|XL|XXL|XXXL)$/i.test(cleanSize)) {
    return { path: '/collections/kleding', euSuffix: false, includeSize: true, includeVendor: true };
  }
  if (/^\d+$/.test(cleanSize)) {
    const num = parseInt(cleanSize, 10);
    if (num <= 35) {
      return { path: '/collections/kids-sneakers', euSuffix: true, includeSize: true, includeVendor: false };
    }
    return { path: '/collections/onze-sneakers', euSuffix: true, includeSize: true, includeVendor: true };
  }
  return { path: '/collections/accesoires', euSuffix: false, includeSize: false, includeVendor: true };
}

async function handleSizeRedirect(event) {
  event.preventDefault();
  event.stopPropagation();

  const currentVendor = window.productData?.vendor || '';
  const selectedSize = getSelectedSize();

  if (!selectedSize) {
    alert('Selecteer eerst een maat om andere producten te bekijken.');
    return;
  }

  const config = getCollectionConfig(selectedSize);
  const sizeParam = 'filter.p.option.Size';
  const vendorParam = 'filter.p.vendor';

  const params = [];
  if (config.includeSize) {
    const sizeValue = config.euSuffix ? selectedSize + ' EU' : selectedSize;
    params.push(`${sizeParam}=${encodeURIComponent(sizeValue)}`);
  }
  if (config.includeVendor && currentVendor) {
    params.push(`${vendorParam}=${encodeURIComponent(currentVendor)}`);
  }

  window.location.href = config.path + (params.length ? '?' + params.join('&') : '');
}

function getSelectedSize() {
  // Method 1: Get from checked radio button (most reliable)
  const selectedSizeInput = document.querySelector('input[name*="Size"]:checked, input[name*="Maat"]:checked, input[data-size]:checked');
  if (selectedSizeInput) {
    const size = selectedSizeInput.value || selectedSizeInput.getAttribute('data-size');
    return size ? size.replace('EU ', '').replace('EU', '').trim() : null;
  }
  
  // Method 2: Fallback - get from all checked variant inputs
  const checkedInputs = document.querySelectorAll('input[type="radio"]:checked');
  const selectedOptions = Array.from(checkedInputs).map(input => input.value);
  
  if (selectedOptions.length > 0) {
    // Find the variant that matches all selected options
    const selectedVariant = productData.variants.find(variant => {
      return selectedOptions.every(option => variant.options.includes(option));
    });
    
    if (selectedVariant) {
      // Assuming size is typically option1, but adjust based on your setup
      return selectedVariant.option1?.replace('EU ', '').replace('EU', '').trim();
    }
  }
  
  return null;
}

async function getProductsWithSameVendorAndSize(currentVendor, size) {
  try {
    // Method 1: Using Shopify's search API with query parameters
    const searchQuery = `vendor:"${currentVendor}" AND (${size} OR "EU ${size}" OR "EU${size}")`;
    const searchUrl = `/search?q=${encodeURIComponent(searchQuery)}&type=product&format=json`;
    
    const response = await fetch(searchUrl);
    
    if (!response.ok) {
      throw new Error(`Search failed: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Further filter the results to ensure they have the exact size available
    const matchingProducts = data.results ? data.results.filter(product => {
      return product.variants && product.variants.some(variant => {
        if (!variant.available) return false;
        
        const cleanSize = size.toString().trim();
        const variantOptions = [
          variant.option1,
          variant.option2, 
          variant.option3,
          variant.title
        ].filter(Boolean);
        
        return variantOptions.some(option => {
          if (!option) return false;
          const cleanOption = option.toString().replace(/EU\s?/gi, '').trim();
          return cleanOption === cleanSize;
        });
      });
    }) : [];
    
    return matchingProducts;
    
  } catch (error) {
    console.error('Search API failed, falling back to collection method:', error);
    
    // Fallback to your existing collection-based method
    return getProductsFromCollection(currentVendor, size);
  }
}

// Fallback method (your existing logic)
async function getProductsFromCollection(currentVendor, size) {
  try {
    const collectionHandle = currentVendor.toLowerCase().replace(/\s+/g, '-');
    const response = await fetch(`/collections/${collectionHandle}/products.json`);
    const data = await response.json();
    
    const matchingProducts = data.products.filter(product => {
      // Check if vendor matches
      const vendorMatch = product.vendor === currentVendor;
      
      // Check if product has the specified size and is available
      const hasSize = product.variants.some(variant => 
        variant.available && 
        (variant.option1 === size || 
         variant.option2 === size || 
         variant.option3 === size ||
         variant.title.includes(size))
      );
      
      return vendorMatch && hasSize;
    });
    
    return matchingProducts;
    
  } catch (error) {
    console.error('Collection method also failed:', error);
    return [];
  }
}

// === ADDED: Magnifying glass tooltip functionality ===
function initializeMagnifyingGlassTooltips() {
  // Check if we're on mobile
  const isMobile = window.innerWidth <= 768;
  
  // If on mobile, don't initialize tooltips
  if (isMobile) {
    return;
  }

  // Create tooltip element
  const tooltip = document.createElement('div');
  tooltip.className = 'magnifier-tooltip';
  document.body.appendChild(tooltip);

  // Add event listeners to all magnifying glass icons
  document.addEventListener('mouseenter', function(e) {
    if (isMobile) return; // Extra check for mobile
    
    // Check if e.target is an Element before using closest
    if (e.target instanceof Element) {
      const magnifierIcon = e.target.closest('.size-magnifier-icon');
      if (magnifierIcon && magnifierIcon.hasAttribute('data-tooltip')) {
        showTooltip(magnifierIcon, tooltip);
      }
    }
  }, true);

  document.addEventListener('mouseleave', function(e) {
    if (isMobile) return; // Extra check for mobile
    
    // Check if e.target is an Element before using closest
    if (e.target instanceof Element) {
      const magnifierIcon = e.target.closest('.size-magnifier-icon');
      if (magnifierIcon && magnifierIcon.hasAttribute('data-tooltip')) {
        hideTooltip(tooltip);
      }
    }
  }, true);

  // Add resize listener to update isMobile state
  window.addEventListener('resize', function() {
    const wasMobile = isMobile;
    const nowMobile = window.innerWidth <= 768;
    
    if (wasMobile !== nowMobile) {
      location.reload(); // Refresh page if switching between mobile and desktop
    }
  });
}

function showTooltip(element, tooltip) {
  const rect = element.getBoundingClientRect();
  const tooltipText = element.getAttribute('data-tooltip');
  
  tooltip.textContent = tooltipText;
  
  // First position the tooltip
  tooltip.style.left = rect.left + 'px';
  tooltip.style.top = (rect.top - 35) + 'px';
  tooltip.classList.add('visible');
  
  // After positioning, check if it's outside viewport and adjust if needed
  const tooltipRect = tooltip.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  
  // Check if tooltip extends beyond right edge of viewport
  if (tooltipRect.right > viewportWidth) {
    // Calculate how much we need to move it left to fit, with increased padding
    const overflow = tooltipRect.right - viewportWidth;
    const newLeft = rect.left - overflow - 30; // Increased padding from 10px to 25px
    tooltip.style.left = newLeft + 'px';
  }
  
  // Check if tooltip extends beyond left edge of viewport
  if (tooltipRect.left < 0) {
    tooltip.style.left = '10px'; // Keep 10px padding from left edge
  }
}

function hideTooltip(tooltip) {
  tooltip.classList.remove('visible');
}
// === END ADDED: Magnifying glass tooltip functionality ===

// === ADDED: Debug code to check magnifying glass elements ===
function debugMagnifyingGlassElements() {
  console.log('=== DEBUG: Magnifying Glass Elements ===');
  const magnifierIcons = document.querySelectorAll('.size-magnifier-icon');
  console.log('Found magnifier icons:', magnifierIcons.length);
  
  magnifierIcons.forEach((icon, index) => {
    console.log(`Icon ${index}:`, icon);
    console.log(`Has data-tooltip:`, icon.hasAttribute('data-tooltip'));
    console.log(`Tooltip text:`, icon.getAttribute('data-tooltip'));
  });
}

// Call debug function after DOM loads
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(debugMagnifyingGlassElements, 1000); // Wait 1 second to ensure elements are loaded
});
// === END DEBUG ===

initializeSizeRedirectButton();

// Add this to your theme.js or product page template
document.addEventListener('DOMContentLoaded', function() {
  const buttonText = document.querySelector('[data-add-to-cart-text]');
  const buttonPrice = document.querySelector('[data-button-price]');
  const ctaDot = document.querySelector('.cta__dot');
  
  // Get the translated sold out text from Shopify's translation system
  // This will automatically use the correct language
  const soldOutTranslated = window.theme?.strings?.soldOut || 
                           document.querySelector('[data-sold-out-text]')?.textContent ||
                           'Sold out'; // fallback
  
  if (buttonText) {
    // Function to check if button shows sold out and hide/show price accordingly
    function updatePriceVisibility() {
      const currentButtonText = buttonText.textContent.trim();
      
      // Check if button text matches the translated sold out text
      const isSoldOut = currentButtonText.toLowerCase().includes(soldOutTranslated.toLowerCase());
      
      if (isSoldOut) {
        if (buttonPrice) buttonPrice.classList.add('hidden');
        if (ctaDot) ctaDot.classList.add('hidden');
      } else {
        if (buttonPrice) buttonPrice.classList.remove('hidden');
        if (ctaDot) ctaDot.classList.remove('hidden');
      }
    }
    
    // Run on page load
    updatePriceVisibility();
    
    // Watch for changes to the button text (when variants change)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        updatePriceVisibility();
      });
    });
    
    observer.observe(buttonText, { 
      childList: true, 
      subtree: true, 
      characterData: true 
    });
  }
  
  // Also listen for variant change events if they exist
  document.addEventListener('variant:change', updatePriceVisibility);
  document.addEventListener('product:variant:change', updatePriceVisibility);
});

/* CRO FIX: Smart Sold Out Button (Rebuild DOM Version) */

function initializeMainButtonRedirect() {
  document.addEventListener('DOMContentLoaded', function() {
    
    const addToCartBtn = document.querySelector('button[name="add"], .product-form__submit, [data-add-to-cart]');
    if (!addToCartBtn) return;

    // 1. Intelligent Text Capture
    let originalText = "In Winkelmandje"; // Default fallback
    const textSpan = addToCartBtn.querySelector('[data-add-to-cart-text]');
    const currentText = textSpan ? textSpan.textContent.trim() : addToCartBtn.textContent.trim();
    
    // Only use the captured text if it's NOT "Sold Out"
    if (currentText && !currentText.toLowerCase().includes('uitverkocht') && !currentText.toLowerCase().includes('sold out')) {
      originalText = currentText;
    }

    function updateMainButton() {
      // 2. Get Source of Truth (Variant ID)
      const idInput = document.querySelector('input[name="id"]');
      const currentVariantId = idInput ? parseInt(idInput.value) : null;
      
      let currentVariant = null;
      if (window.productData && window.productData.variants) {
        currentVariant = window.productData.variants.find(v => v.id === currentVariantId);
      }

      // 3. Check Availability
      const isSoldOut = currentVariant ? !currentVariant.available : false;

      if (isSoldOut) {
        // --- STATE: SOLD OUT ---
        const currentVendor = window.productData?.vendor || 'Kyaro';
        const rawSize = typeof getSelectedSize === 'function' ? getSelectedSize() : "";
        
        // selectedSize is stripped of "EU" so the button always looks clean 
        // e.g., "36" instead of "36 EU", and "M" stays "M"
        const selectedSize = rawSize.replace(/EU/gi, '').trim();
        
        // Construct HTML for the button
        let newHtml = "";
        if (selectedSize) {
           newHtml = `Bekijk andere <b>${currentVendor}</b> in maat <b>${selectedSize}</b>`;
        } else {
           newHtml = `Bekijk andere <b>${currentVendor}</b> in mijn maat`;
        }

        // Wipe button content and replace with ours
        addToCartBtn.innerHTML = newHtml;
        
        addToCartBtn.classList.add('cro-redirect-btn');
        addToCartBtn.disabled = false; 
        addToCartBtn.removeAttribute('disabled');
        
        // --- NEW REDIRECT LOGIC ---
        addToCartBtn.onclick = function(e) {
          e.preventDefault(); // Stop standard form submission
          
          // 1. Convert Vendor Name to a Shopify Collection Handle
          let vendorHandle = 'all'; 
          if (currentVendor && currentVendor !== 'Kyaro') {
              vendorHandle = currentVendor.toLowerCase()
                  .replace(/['"]/g, '')               
                  .replace(/[^a-z0-9]+/g, '-')        
                  .replace(/(^-|-$)/g, '');           
          }

          // 2. Determine Product Category for Size Formatting
          const productType = (window.productData?.type || window.productData?.product_type || "").toLowerCase();
          const isSneakerCategory = productType.includes('sneaker');
          
          // Fallback: If category is missing, check if the size is purely numbers/fractions (e.g., "36" or "40 2/3")
          const isNumericSize = /^[\d\s\/\.,]+$/.test(selectedSize);

          // 3. Construct the exact URL parameters
          const params = new URLSearchParams();
          if (selectedSize) {
              let filterSizeValue = selectedSize;
              
              // If it's a Sneaker (by category or numeric format), append " EU" 
              // URLSearchParams will automatically turn the space into a "+" (e.g. 36+EU)
              if (isSneakerCategory || (productType === "" && isNumericSize)) {
                  filterSizeValue = selectedSize + ' EU';
              }
              
              params.set('filter.v.option.size', filterSizeValue); 
          }
          
          params.set('filter.v.availability', '1');
          params.set('sort_by', 'best-selling');

          // 4. Redirect the user
          window.location.href = `/collections/${vendorHandle}?${params.toString()}`;
        };

      } else {
        // --- STATE: AVAILABLE (Restore) ---
        
        addToCartBtn.classList.remove('cro-redirect-btn');
        addToCartBtn.onclick = null; 

        // CRITICAL FIX: Rebuild the HTML structure completely
        addToCartBtn.innerHTML = `<span data-add-to-cart-text>${originalText}</span>`;

        // Ensure button is enabled
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('disabled');
        
        // Restore price if hidden (theme specific helper)
        const priceSpan = document.querySelector('[data-button-price]');
        if(priceSpan) priceSpan.classList.remove('hidden');
      }
    }

    // --- EVENT LISTENERS ---
    const inputs = document.querySelectorAll('input[name*="Size"], input[name*="Maat"], input[data-size], select[name="id"]');
    inputs.forEach(input => {
      input.addEventListener('change', () => setTimeout(updateMainButton, 50));
    });

    // --- ACTIVE DEFENSE ---
    const observer = new MutationObserver(function(mutations) {
      const idInput = document.querySelector('input[name="id"]');
      const currentVariantId = idInput ? parseInt(idInput.value) : null;
      const currentVariant = window.productData?.variants?.find(v => v.id === currentVariantId);
      
      // If Available but text is wrong -> Force Restore
      if (currentVariant && currentVariant.available) {
          const btnText = addToCartBtn.textContent.toLowerCase();
          if (btnText.includes('uitverkocht') || btnText.includes('sold out') || btnText.includes('bekijk andere')) {
              // Rebuild
              addToCartBtn.innerHTML = `<span data-add-to-cart-text>${originalText}</span>`;
              addToCartBtn.classList.remove('cro-redirect-btn');
              addToCartBtn.onclick = null;
              addToCartBtn.disabled = false;
              addToCartBtn.removeAttribute('disabled');
          }
      }
    });

    observer.observe(addToCartBtn, { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['disabled', 'class'] 
    });

    // Initial Run
    updateMainButton();
  });
}

initializeMainButtonRedirect();